import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, GiftIcon, SearchIcon, ZapIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { productImage, totalBonuses, totalVolumes } from '../data/offer';
const highlights = [{
  icon: BookOpenIcon,
  label: `${totalVolumes} tomos premium`
}, {
  icon: GiftIcon,
  label: `${totalBonuses} bonos estratégicos`
}, {
  icon: ZapIcon,
  label: 'Acceso inmediato'
}];
export function Hero() {
  const scrollToPricing = () => document.getElementById('pricing')?.scrollIntoView({
    behavior: 'smooth',
    block: 'start'
  });
  return <section className="relative isolate overflow-hidden bg-navy-950" data-id="element-111" data-mp="sai4p4p7cx7b">
      <div className="metal-silver h-2 w-full" aria-hidden="true" data-id="element-112" data-mp="nc86smc3fii0" />

      <div className="mx-auto max-w-5xl px-4 pb-14 pt-12 text-center lg:pb-20 lg:pt-16" data-id="element-113" data-mp="nbyid36p5jef">
        <motion.p initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="inline-flex items-center gap-2 rounded-md border border-silver-400/40 bg-navy-800 px-4 py-2 text-xs font-extrabold uppercase tracking-[.14em] text-silver-100" data-id="element-114" data-mp="3d33ecx6girk8">
          <SearchIcon className="h-4 w-4" aria-hidden="true" data-id="element-115" data-mp="39ausbgoyhsyt" /> Megapack Criminalística Listo
        </motion.p>

        <motion.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.06,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto mt-5 max-w-4xl text-balance text-4xl font-extrabold leading-[1.05] text-white sm:text-5xl lg:text-6xl" data-id="element-116" data-mp="3e8mqgsg72bbg">
          Todo tu año de Criminalística
          <br data-id="element-117" data-mp="2viy3blil3z6n" />
          <span className="metal-text underline decoration-silver-300 decoration-[6px] underline-offset-[10px]" data-id="element-118" data-mp="2vieuqvetqn5a">
            resuelto en una tarde.
          </span>
        </motion.h1>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.12,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto mt-10 max-w-3xl rounded-2xl border border-silver-400/30 bg-navy-900 p-3 shadow-xl shadow-black/40 sm:p-5" data-id="element-119" data-mp="2lkqwvwlx8ziw">
          <img src={productImage} alt="Megapack Criminalística Listo: nueve tomos y cinco bonos sobre fundamentos, lugar de los hechos, indicios y evidencias, dactiloscopía, biología forense, documentos, química, criminalística digital y enseñanza de la criminalística" className="mx-auto w-full rounded-xl" data-id="element-120" data-mp="id9tgcjzi9ta" />
        </motion.div>

        <div className="mt-9" data-id="element-121" data-mp="1126nqgfdt2bi">
          <Button onClick={scrollToPricing} arrow className="w-full sm:w-auto" data-id="element-122" data-mp="111ew1gownoqi">
            Quiero mi Megapack ahora
          </Button>
        </div>

        <ul className="mt-7 flex flex-wrap justify-center gap-2 text-xs font-bold text-silver-100" data-id="element-123" data-mp="3lsypkqaae6eu">
          {highlights.map(({
          icon: Icon,
          label
        }) => <li key={label} className="inline-flex items-center gap-1.5 rounded-md border border-silver-400/30 bg-navy-900 px-3 py-2" data-id="element-124" data-mp="3hpsglavsi14o">
              <Icon className="h-3.5 w-3.5 text-silver-300" aria-hidden="true" data-id="element-125" data-mp="21bxzf8gseycx" />
              {label}
            </li>)}
        </ul>
      </div>
    </section>;
}